import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select';
import { currentDateAndTime, decodeData } from '../../Constants/constants';

const monthOptions = [
    { value: 0, label: '0 Month' },
    { value: 1, label: '1 Month' },
    { value: 2, label: '2 Month' },
    { value: 3, label: '3 Month' },
    { value: 4, label: '4 Month' },
    { value: 5, label: '5 Month' },
    { value: 6, label: '6 Month' },
    { value: 7, label: '7 Month' },
    { value: 8, label: '8 Month' },
    { value: 9, label: '9 Month' },
    { value: 10, label: '10 Month' },
    { value: 11, label: '11 Month' },
    { value: 12, label: '12 Month' },

];
class LeaveCategory extends Component {

    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            leave_category_id: 0,
            leave_name: "",
            carry_forward: "",
            yearly_limit: "",
            monthly_proportionately: "0",
            leave_applicable_after: 0,
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            errors: {},
            decodedData: [],

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    GetInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetLeaveCategoryInfo?leave_category_id=${this.state.leave_category_id}`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.setState(
                    {
                        leave_name: data[0].leave_name,
                        carry_forward: data[0].carry_forward,
                        yearly_limit: data[0].yearly_limit,
                        monthly_proportionately: data[0].monthly_proportionately,
                        leave_applicable_after: data[0].leave_applicable_after,
                        errors: {
                            ...this.state.errors,
                            leave_name: '',
                            carry_forward: '',
                            yearly_limit: '',
                            monthly_proportionately: '',
                            leave_applicable_after: ''
                        }

                    }
                )
            }
        });
    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetLeaveCategories`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }


    handleSubmit = (e) => {
        e.preventDefault();

        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        const formData = {
            leave_name: this.state.leave_name,
            carry_forward: this.state.carry_forward,
            yearly_limit: this.state.yearly_limit,
            monthly_proportionately: this.state.monthly_proportionately,
            leave_applicable_after: this.state.leave_applicable_after,
            date: currentDateAndTime(),
        };

        if (this.state.leave_category_id !== 0) {
            formData.leave_category_id = this.state.leave_category_id;
        }

        axios.post(`${apiURL}Masters/CreateLeaveCategory`, formData, { headers }).then((response) => {
            const { success } = response.data;
            if (success === true) {
                this.resetForm();
                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                });
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    timer: 2000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            } else {
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    timer: 2000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                });
            }
        });
    };



    resetForm = () => {
        this.setState({
            leave_category_id: 0,
            leave_name: '',
            carry_forward: '',
            yearly_limit: '',
            monthly_proportionately: 0,
            leave_applicable_after: 0,
            errors: {}
        });
    };

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: '1, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    leave_category_id: id,
                    date: currentDateAndTime(),
                };
                axios
                    .post(`${apiURL}Masters/DeleteLeaveCategory`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {

        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }
    handleRadioChange = (name, value) => {

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };


    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };


    handleSelectChange = (name, selectedOption) => {

        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };


    validateForm = () => {
        const errors = {};

        if (!this.state.leave_name) {
            errors.leave_name = 'Leave Name is required';
        }
        if (this.state.carry_forward === '') {
            errors.carry_forward = 'Carry Forward is required';
        }
        if (this.state.yearly_limit === '') {
            errors.yearly_limit = 'Yearly Limit is required';
        }
        if (!this.state.leave_applicable_after && this.state.leave_applicable_after !== 0) {
            errors.leave_applicable_after = 'Leave Applicable After is required';
        }

        return errors;
    };


    render() {
        const { errors } = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Leave Category`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Leave Category</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form className="row">
                                                    <div className="col-md-12">
                                                        <label htmlFor="leave_name" className="form-label">Leave Name</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.leave_name ? 'is-invalid' : ''}`}
                                                            id="leave_name"
                                                            name="leave_name"
                                                            value={this.state.leave_name}
                                                            onChange={this.handleInputChange}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            placeholder="Enter Leave Name"
                                                        />
                                                        {errors.leave_name && <div className="invalid-feedback">{errors.leave_name}</div>}

                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="carry_forward" className="form-label">Carry Forward</label>
                                                        <input
                                                            type="number"
                                                            className={`form-control ${errors.carry_forward ? 'is-invalid' : ''}`}
                                                            id="carry_forward"
                                                            name="carry_forward"
                                                            value={this.state.carry_forward}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Carry Forward"
                                                        />
                                                        {errors.carry_forward && <div className="invalid-feedback">{errors.carry_forward}</div>}

                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="yearly_limit" className="form-label">Yearly Limit</label>
                                                        <input
                                                            type="number"
                                                            className={`form-control ${errors.yearly_limit ? 'is-invalid' : ''}`}
                                                            id="yearly_limit"
                                                            name="yearly_limit"
                                                            value={this.state.yearly_limit}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter Yearly Limit"
                                                        />
                                                        {errors.yearly_limit && <div className="invalid-feedback">{errors.yearly_limit}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <div>
                                                            <label htmlFor="monthly_proportionately" className="form-label">Monthly Proportionately:</label>
                                                        </div>
                                                        <div className="form-check form-check-inline mt-2">
                                                            <input
                                                                type="radio"
                                                                id="monthly_proportionately1"
                                                                name="monthly_proportionately"
                                                                value="1"
                                                                checked={this.state.monthly_proportionately == '1'}
                                                                disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                                onChange={() => this.handleRadioChange('monthly_proportionately', '1')}
                                                                className={`form-check-input ${errors.monthly_proportionately ? 'is-invalid' : ''}`}
                                                            />
                                                            <label htmlFor="monthly_proportionately1" className="form-check-label">Yes</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="monthly_proportionately0"
                                                                name="monthly_proportionately"
                                                                value="0"
                                                                checked={this.state.monthly_proportionately == '0'}
                                                                disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                                onChange={() => this.handleRadioChange('monthly_proportionately', '0')}
                                                                className={`form-check-input ${errors.monthly_proportionately ? 'is-invalid' : ''}`}
                                                            />
                                                            <label htmlFor="monthly_proportionately0" className="form-check-label">No</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="leave_applicable_after" className="form-label"> Leave Applicable After:</label>
                                                        <Select
                                                            id="leave_applicable_after"
                                                            name="leave_applicable_after"
                                                            value={monthOptions.find(option => option.value === this.state.leave_applicable_after)}
                                                            onChange={(selectedOption) => this.handleSelectChange('leave_applicable_after', selectedOption)}
                                                            options={monthOptions}
                                                            isDisabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            placeholder="Select Your Leave Applicable After"
                                                            required
                                                        />
                                                        {errors.leave_applicable_after && <div className="text-danger">{errors.leave_applicable_after}</div>}
                                                    </div>
                                                    { (this.state.decodedData?.includes(2) || this.state.decodedData?.includes(3)) && (
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            // this.state.leave_category_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                            !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                    this.handleSubmit(e)
                                                                }}
                                                                disabled={!this.state.leave_category_id}
                                                                buttonName={'Update'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />) : (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                        this.handleSubmit(e)
                                                                    }}
                                                                buttonName={this.state.leave_category_id ? 'Update':'Save'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />)

                                                        }

                                                        {
                                                            this.state.leave_category_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />New</button> : <div></div>

                                                        }
                                                    </div>)}
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div className="col-md-12">
                                        <table className={`table table-bordered table-stripped`}>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th>Leave Name</th>
                                                    <th>Carry Forward</th>
                                                    <th>Yearly limit</th>
                                                    <th>Monthly Proportionately</th>
                                                    <th>Leave Applicable After</th>
                                                    { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                    <th width={120} className=' text-center'>Action</th>)}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr key={row.leave_category_id}>
                                                            <td>{row.leave_name}</td>
                                                            <td>{row.carry_forward}</td>
                                                            <td>{row.yearly_limit}</td>
                                                            <td>{row.monthly_proportionately_label}</td>
                                                            <td>{row.leave_applicable_after}  <span>Months</span></td>
                                                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                            <td className='d-flex justify-content-around'>
                                                                { this.state.decodedData?.includes(3) && ( 
                                                                    <button type='button' onClick={() => this.setState({ leave_category_id: row.leave_category_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                { this.state.decodedData?.includes(4) && ( 
                                                                    <button onClick={() => this.handleDelete(row.leave_category_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                            <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={6} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </tfoot>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(LeaveCategory);